export const SET_BUSINESS_INFO = 'BUSINESS_INFO_REGISTRATION/SET_BUSINESS_INFO';
export const SET_ACTIVATION = 'BUSINESS_INFO_REGISTRATION/SET_ACTIVATION';
export const SET_CHARGE_TYPE = 'BUSINESS_INFO_REGISTRATION/SET_CHARGE_TYPE';
export const SET_CHARGE = 'BUSINESS_INFO_REGISTRATION/SET_CHARGE';
export const CLEAR_CHARGE = 'BUSINESS_INFO_REGISTRATION/CLEAR_CHARGE';
export const SET_SUPERLOGICA_LIST = 'BUSINESS_INFO_REGISTRATION/SET_SUPERLOGICA_LIST';
export const HANDLE_LOADING = 'BUSINESS_INFO_REGISTRATION/HANDLE_LOADING';
export const CLEAR_BUSINESS_INFO_REGISTRATION = 'BUSINESS_INFO_REGISTRATION/CLEAR_BUSINESS_INFO_REGISTRATION';